module.exports = __webpack_public_path__ + "static/media/sneha_desu_banner.637b6427.webp";